import { createContext, useContext } from 'react';
import noop from 'ui-components/default-props/noop';

export type ShippySidebarOpenSource =
  | 'shippy_button'
  | 'help_menu_chat'
  | 'launch_chat_route'
  | 'store_error_modal'
  | 'wallet_error'
  | 'labs_cta';

type ShippySidebarContextValue = {
  isOpen: boolean;
  hasUnreadMessages: boolean;
  openSidebar: (source?: ShippySidebarOpenSource) => void;
  closeSidebar: () => void;
  toggleSidebar: (source?: ShippySidebarOpenSource) => void;
  setHasUnreadMessages: (hasUnread: boolean) => void;
};

export const ShippySidebarContext = createContext<ShippySidebarContextValue>({
  isOpen: false,
  hasUnreadMessages: false,
  openSidebar: noop,
  closeSidebar: noop,
  toggleSidebar: noop,
  setHasUnreadMessages: noop,
});

export const useShippySidebar = () => useContext(ShippySidebarContext);
